import { render } from "./CarrousselImage.vue?vue&type=template&id=7b3fa80a&scoped=true"
import script from "./CarrousselImage.vue?vue&type=script&lang=js"
export * from "./CarrousselImage.vue?vue&type=script&lang=js"

import "./CarrousselImage.vue?vue&type=style&index=0&id=7b3fa80a&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/ixperya2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b3fa80a"]])

export default __exports__